// frontend/src/pages/StartPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/StartPage.css';


function StartPage({ setCharacter, setMessages, setStarted }) {
  const [localCharacter, setLocalCharacter] = useState({
    name: '',
    race: '',
    class: '',
    appearance: '',
    backstory: '',
    weapons: '',
    spells: ''
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token !== process.env.REACT_APP_AUTH_TOKEN) {
      navigate('/');
    }
  }, []);
  

  const startGame = async () => {
    try {
      setLoading(true); // Show loading
  
      setCharacter(localCharacter); // Save character globally
  
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ character: localCharacter })
      });
  
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || "Unknown server error");
      }
  
      const data = await res.json();
      setMessages([{ sender: 'AI', text: data.response }]);
      setStarted(true);
      navigate('/game');
    } catch (err) {
      console.error("Failed to start game:", err.message);
      alert(`Error: ${err.message}`);
    } finally {
      setLoading(false); // Always stop loading, success or fail
    }
  };
  
  

  return (
    <div className="setup-container">
      <h1>Describe Your Character</h1>
      <input placeholder="Name" onChange={e => setLocalCharacter({ ...localCharacter, name: e.target.value })} />
      <input placeholder="Race" onChange={e => setLocalCharacter({ ...localCharacter, race: e.target.value })} />
      <input placeholder="Appearance" onChange={e => setLocalCharacter({ ...localCharacter, appearance: e.target.value })} />
      <textarea placeholder="Backstory" onChange={e => setLocalCharacter({ ...localCharacter, backstory: e.target.value })} />
      <input
          placeholder="Class (e.g., Fighter, Wizard)"
          onChange={e => setLocalCharacter({ ...localCharacter, class: e.target.value })}
        />
        <input
          placeholder="Weapons (e.g., Sword, Bow, Staff)"
          onChange={e => setLocalCharacter({ ...localCharacter, weapons: e.target.value })}
        />
        <input
          placeholder="Spells (e.g., Fireball, Cure Wounds)"
          onChange={e => setLocalCharacter({ ...localCharacter, spells: e.target.value })}
        />
          {loading ? (
      <div className="loading-container">
        <div className="magic-spinner"></div>
        <p className="loading-message">✨ The Dungeon Master is weaving a tale... ✨</p>
      </div>
    ) : (
      <button onClick={startGame}>Start Adventure</button>
    )}
    </div>
  );
}

export default StartPage;
